import { render } from "./ShowResult.vue?vue&type=template&id=ba12f3cc&scoped=true"
import script from "./ShowResult.vue?vue&type=script&lang=ts"
export * from "./ShowResult.vue?vue&type=script&lang=ts"

import "./ShowResult.vue?vue&type=style&index=0&id=ba12f3cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba12f3cc"

export default script